import React from "react"


import { Splitter, SplitterPanel } from 'primereact/splitter';
import { TabView, TabPanel } from 'primereact/tabview';
import DocumentView from "../../../common/DocumentView";

import "../index.css"

const BuyerPOAndInvoiceSplitView = (props) => {
    const { buyerPOPdfURL, buyerPODocProof } = props

    const renderDocument = (docURL) => {
        return (
            <>
                {
                    docURL ?
                        <DocumentView fileUrl={docURL} showZoomControl={true}/>
                        : <p className='text-center'>The document is not found.</p>
                }
            </>
        )
    }

    return (
        <div className="">
            {
                <TabView className="mt-1 invoice-tabview">
                    <TabPanel header="Client PO Doc & Invoice">
                        <div style={{ height: 'calc(100vh - 100px)' }}>
                            <Splitter style={{ width: '100%', height: '100%' }}>
                                <SplitterPanel style={{ width: '50%', height: '82%' }}>
                                    {renderDocument(buyerPODocProof)}
                                </SplitterPanel>
                                <SplitterPanel style={{ width: '50%', height: '82%' }}>
                                    {props.renderHTMLInvoiceDocument()}
                                </SplitterPanel>
                            </Splitter>
                            <style>
                                {` .p-splitter-gutter { display: none !important; } `}
                            </style>
                        </div>
                    </TabPanel>
                    <TabPanel header="BuyerPO & Invoice">
                        <div style={{ height: 'calc(100vh - 100px)' }}>
                            <Splitter style={{ width: '100%', height: '100%' }}>
                                <SplitterPanel size={50} style={{ width: '50%', height: '82%' }}>
                                    {renderDocument(buyerPOPdfURL)}
                                </SplitterPanel>
                                <SplitterPanel style={{ width: '50%', height: '82%' }}>
                                    {props.renderHTMLInvoiceDocument()}
                                </SplitterPanel>
                            </Splitter>
                            <style>
                                {` .p-splitter-gutter { display: none !important; } `}
                            </style>
                        </div>
                    </TabPanel>
                </TabView>
            }
        </div>
    )
}

export default BuyerPOAndInvoiceSplitView